import { render, staticRenderFns } from "./CustomManager.vue?vue&type=template&id=08c37df6&"
import script from "./CustomManager.vue?vue&type=script&lang=js&"
export * from "./CustomManager.vue?vue&type=script&lang=js&"
import style0 from "./CustomManager.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jasonliuhan/Documents/project/jcfy-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08c37df6')) {
      api.createRecord('08c37df6', component.options)
    } else {
      api.reload('08c37df6', component.options)
    }
    module.hot.accept("./CustomManager.vue?vue&type=template&id=08c37df6&", function () {
      api.rerender('08c37df6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/container/CustomManager.vue"
export default component.exports